module.exports = __webpack_public_path__ + "img/no-bank-statement.cbebfa60.svg";